{
	"columns":[
        {
			"header_id": "accured",
			"header_label": "Accrued",
			"jsonpath":  "accrued" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
        {
			"header_id": "used",
			"header_label": "Used",
			"jsonpath":  "used" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
        {
			"header_id": "Balance",
			"header_label": "Balance",
			"jsonpath":  "balance" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "availableToUse",
			"header_label": "Available to Use",
			"jsonpath":  "availableToUse" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "calculatedCap",
			"header_label": "Calculated Cap",
			"jsonpath":  "calculatedCap" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "adjustedCap",
			"header_label": "Adjusted Cap",
			"jsonpath":  "adjustedCap" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
        {
            "header_id": "calculatedUsageCap",
            "header_label": "Calculated Usage Cap",
            "jsonpath":  "calculatedUsageCap" ,
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        },
        {
            "header_id": "adjustedUsageCap",
            "header_label": "Adjusted Usage Cap",
            "jsonpath":  "adjustedUsageCap" ,
            "isDisplayedAtHeader": "y",
            "isSearchable": "y"
        }
    ],
	"buttons": [],
    "apiDetails": "providerSickTime.json",
	"pageName": "providersicktimelist1",
	"orderByColumn": ["tasMasterPayrollScheduleId"],
	"orderBy": ["desc"]
}
